var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconExploreMostLoved(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Explore",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "solid/box-heart",
    style: {
      mixBlendMode: "overlay"
    },
    fill: "#FCFCFC"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M442.333333,175 L395.416667,87.5833329 C391.75,76.6666662 381.583334,69.3333329 370.083334,69.3333329 L269.333333,69.3333329 L269.333333,176 L441.583334,176 C441.916667,175.583333 442,175.416666 442.333333,175 L442.333333,175 Z M69.3333329,202.666667 L69.3333329,416 C69.3333329,430.75 81.2499996,442.666667 95.9999996,442.666667 L416,442.666667 C430.75,442.666667 442.666667,430.75 442.666667,416 L442.666667,202.666667 L69.3333329,202.666667 Z M323.583334,327 L263.083333,386.5 C259.166667,390.333334 252.833333,390.333334 248.916667,386.5 L188.416666,327 C170.833333,309.75 171.916666,281.083333 191.5,265.166667 C208.583333,251.25 234.083333,253.75 249.833333,269.166667 L256,275.25 L262.166667,269.166667 C277.833333,253.75 303.333333,251.25 320.5,265.166667 C340.083334,281.083333 341.083334,309.666667 323.583334,327 L323.583334,327 Z M242.666666,176 L242.666666,69.3333329 L141.916666,69.3333329 C130.416666,69.3333329 120.25,76.6666662 116.583333,87.5833329 L69.6666662,175 C69.9999995,175.416666 70.0833329,175.583333 70.4166662,176 L242.666666,176 Z",
    id: "box-heart"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExploreMostLoved);
export default __webpack_public_path__ + "static/media/iconExploreMostLoved.db081301.svg";
export { ForwardRef as ReactComponent };